import { ElectoralDataVM, VoterDetailFormVM } from 'electoral/view-models/voter-detail';
import { PersonSearchStorageVM } from 'shell/view-models/search-anpr';
import { transformFamilyCoexistence } from 'shell/utils/consult-person/response-transformer/family/family-coexistence';
import { transformPerson } from 'shell/utils/consult-person/response-transformer/person/person';
import { transformCitizenship } from 'shell/utils/consult-person/response-transformer/registry-office/citizenship';
import { transformGenerality } from 'shell/utils/consult-person/response-transformer/registry-office/generality';
import { transformerElectoralDataANPR } from './transformer-electoral-anpr-data';
import { DateTime } from 'luxon';
import { formatElectoralState } from 'shell/utils/electoral-state-formatter';
import { ElectoralCard } from 'shell/models/person/electoral-card';
import { reasons } from 'shell/components/shared/list-reasons';

export const transformerVoterHistoric = (response: ElectoralCard): ElectoralDataVM => {
  const data = response || {};
  let motivoPreviousCard;
  if (data?.motivoRilascioTesseraPrecedente) {
    motivoPreviousCard = reasons?.find(
      (item) => item?.id === data?.motivoRilascioTesseraPrecedente
    )?.value;
  } else {
    motivoPreviousCard = undefined;
  }

  return {
    indicatoreListaC: data?.indicatoreListaC,
    indicatoreListaE: data?.indicatoreListaE,
    autorizzazioneDocumenti: data?.autorizzazioneDocumenti,
    fiscalCode: data?.codiceFiscale || undefined,
    istatCodeBirth: data?.codiceLuogoNascita || undefined,
    surname: data?.cognome || undefined,
    withoutSurname: !Boolean(data.cognome),
    name: data?.nome || undefined,
    withoutName: !Boolean(data?.nome),
    dossier: data?.fascicolo || undefined,
    electorState: formatElectoralState(data.stato || ''),
    inscriptionYear: data?.annoIscrizione
      ? DateTime.fromISO(data?.annoIscrizione).toFormat('yyyy')
      : undefined,
    section: data?.sezioneElettorale || undefined,
    sectionProgressive: data?.progressivoSezione || undefined,
    generalListNumber: data?.numeroListaGenerale || undefined,
    zone: data?.zona || undefined,
    room: data?.collegioCamera || undefined,
    senate: data?.collegioSenato || undefined,
    senateUni: data?.collegioSenatoUninominale || undefined,
    senatePluri: data?.collegioSenatoPlurinominale || undefined,
    roomUni: data?.collegioCameraUninominale || undefined,
    roomPluri: data?.collegioCameraPlurinominale || undefined,
    province: data?.collegioProvinciale || undefined,
    previousCardNumber: data?.numeroTesseraPrecedente || undefined,
    previousReleaseDate: data?.dataRilascioTesseraPrecedente
      ? DateTime.fromISO(data?.dataRilascioTesseraPrecedente).toFormat('dd/MM/yyyy')
      : undefined,
    previousReleaseReason: motivoPreviousCard,
    previousCardState: data?.descrizioneStatoTessera || undefined,
    newReleaseDate: DateTime.now().toFormat('dd/MM/yyyy'),
    blockError: data?.descrizioneErroreBloccante || undefined,
    nonBlockError: data?.descrizioneErroreNonBloccante || undefined,
    flagNewCard: data?.tesseraNuova || undefined,
    flagArchived: data?.tesseraArchviata || undefined,
    flagPodest: data?.annullamentoPOTDESTE || undefined,
    flagAire: data?.flagAIRE || undefined,
    flagAuthoriaztion: data?.flagAutorizzazzione || undefined,
    printCardState: data?.annullamentoPOTDESTE || undefined,
    placeOfBirth: data?.descrizioneLuogoNascita || undefined,
    provinceOfBirth: data?.provNazLuogoNascita || undefined,
    dateOfBirth: data?.dataNascita
      ? DateTime.fromISO(data?.dataNascita).toFormat('dd/MM/yyyy')
      : undefined,
    mayorName: data?.nomeSindaco || undefined,
    electoralSection: data?.sezioneElettorale || undefined,
    sectionAddress: data?.indirizzoSezione || undefined,
    addressName: data?.nomeVia || undefined,
    civic: data?.numeroCivico || undefined,
    crossed: data?.barrato || undefined,
    electoralSurname: data.cognomeElettore || undefined,
    electoralName: data.nomeElettore || undefined,
    codePlaceResidence: data.codiceLuogoResidenza || undefined,
    residenceDescription: data.descrizioneLuogoResidenza || undefined,
    provNatPlaceResidence: data.provNazLuogoResidenza || undefined,
    address: data.indirizzo || undefined,
    newReleaseReason:
      data.flagAIRE === '*' ? '7' : data.tesseraArchviata?.toUpperCase() === 'SI' ? '4' : undefined,
    anomalyList: data?.anomalieList?.map((item) => ({
      code: item?.codiceAnomalia,
      description: item?.descrizioneAnomalia,
      insertDate: item?.dataRegistrazioneAnomalia
        ? DateTime.fromISO(item?.dataRegistrazioneAnomalia).toFormat('dd/MM/yyyy')
        : '',
    })),
    actNumber: data?.numeroAttoNascita?.toString(),
    actPart: data?.parteAttoNascita,
    actSerie: data?.serieAttoNascita,
    actVolume: data?.volumeAttoNascita,
    actYear: data?.annoAttoNascita?.toString(),
  };
};

export const formatterInitialState = (
  personTable: PersonSearchStorageVM | undefined,
  electoralData: ElectoralDataVM
): VoterDetailFormVM => {
  let values: VoterDetailFormVM = {
    electoralDataANPR: {
      flagVoter: false,
    },
  };

  const [subject] =
    personTable?.subject?.dati3002?.risposta3002OK?.listaSoggetti?.datiSoggetto || [];

  if (subject) {
    const person = transformPerson(subject);

    const generality = transformGenerality(subject);

    const family = transformFamilyCoexistence(subject);

    const citizenship = transformCitizenship(subject);

    const electoralDataANPR = transformerElectoralDataANPR(subject);

    values = {
      ...values,
      person,
      citizenship,
      family,
      generality,
      listaElettorale: subject.listaElettorale,
      electoralData,
      electoralDataANPR: {
        ...values.electoralDataANPR,
        ...electoralDataANPR,
      },
    };
  }
  return values;
};
